import "../sass/main.scss"
// Our modules / classes
//import mscsNews from "./modules/mscsNews"
import piwigo from "./modules/piwigo"
// Instantiate a new object using our modules/classes
const Piwigo = new piwigo()



